import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import MediaList from "../../components/admincomponents/MediaList";

function AdminMedia({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <MediaList  />            
    </>
  );
}

export default AdminMedia;
